import _ from 'underscore';
import Backbone from 'backbone';

var MessageModel = Backbone.Model.extend({
  defaults: function () {
    return {
      title: '',
      message: '',
      onConfirm: _.noop,
      onCancel: _.noop,
      cancelText: '취소',
      confirmText: '확인',
      isVisible: false,
      hasConfirm: false,
      hasCancel: false,
      noWrapMessage: false
    };
  },

  hide: function () {
    this.set(this.defaults());
  },

  show: function (title, message, onConfirm, options) {
    var additionalOptions = (_.isObject(options) && options) || {};
    this.set(
      _.extend(
        {
          title: title,
          message: message,
          onConfirm: _.isFunction(onConfirm) ? onConfirm : _.noop,
          hasConfirm: true,
          hasCancel: _.isFunction(additionalOptions.onCancel) ? true : false,
          onCancel: null,
          isVisible: true
        },
        additionalOptions
      )
    );
  },

  showPrelude: function (message, onConfirm) {
    this.set({
      title: '게임 실행 안내',
      message: message,
      onConfirm: _.isFunction(onConfirm) ? onConfirm : _.noop,
      confirmText: _.isFunction(onConfirm) ? '실행' : '확인',
      hasConfirm: true,
      hasCancel: false,
      isVisible: true
    });
  }
});

export var message = new MessageModel();
